<div class="right_col" role="main">
  <p>
    Session expired. Please login again.
  </p>
</div>